import './DetailsProduct.css'

interface Props {
    title: String | undefined
    description: String | undefined
    imageSrc: String | undefined
}

const DetailsProduct = (props: Props) => {
    return (
        <div className="details-product-main-container" >
            {
                !!props.imageSrc ? <img className='details-product-image' src={`${props.imageSrc}`} alt='title-image'></img> : <></>
            }
            <div className="details-product-column">
                {
                    !!props.title ? <div className='details-product-title'> {props.title} </div> : <></>
                }
                {
                    !!props.description ? <div className='details-product-description'> {props.description} </div> : <></>
                }
            </div>
        </div>
    )
}

export default DetailsProduct
